// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"aaa699ff","212":"aaa699ff"}[chunkId] + ".chunk.css";
};